import React from "react";
import { useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';

const SteelMaterialPicker = ({onCustomEvent, maxId}, ref) => {
  const { t } = useTranslation();
  const [selectValue, setSelectValue] = React.useState(2);
  const [maxVal, setMaxVal] = React.useState(maxId);

  const onChange = (event) => {
    const value = event.target.value;
    setSelectValue(value);
    sendDataToParent(value);
    console.log(event.target.value);
  };
  useImperativeHandle(ref, () => ({
    getData: getData,
    setMaxId: setMaxId,
  }));
  const getData = () => {
    return selectValue;
  };
  const sendDataToParent = (value) => {
    if (typeof onCustomEvent !== 'undefined')
    onCustomEvent(value);
  }
  const setMaxId = (l) => {
    if (l) {
      setMaxVal(l);
    }
  };


  const materialDatabase = [
    { label: "S235", value: "1" },
    { label: "S275", value: "2" },
    { label: "S355", value: "3" },
    { label: "S450", value: "4" }
  ];

  const getOptions = () => {
    var newList = [];
    for (const element of materialDatabase) {
      if (element.value <= maxVal) {
        newList.push(element);
      }
    }
    return newList;
  };

  return (
    <div class="form-col1_6">
      <label class="form-label" for="grid-ServiceClass">
        {t('MaterialePiastra')}
      </label>
      <select class="form-select" id="grid-ServiceClass" name="grid-ServiceClass" onChange={onChange} defaultValue={selectValue}>
        {getOptions().map((option) => (
          <option value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  );
}

export default React.forwardRef(SteelMaterialPicker);
